<div
  class="entry-field"
  [ngClass]="{
    'entry-field--disabled': disableConditionally || isDisabled || isState,
    'entry-field--sandwich': isSandwich,
    'entry-field--readonly': isReadonly
  }"
>
  <div class="input-label-container">
    <input
      *ngIf="!isServer"
      type="{{ inputType }}"
      name="{{ componentId }}"
      class="entry-field__input"
      [placeholder]="noLabel || alwaysShowPlaceholder ? placeholder : '&nbsp;'"
      [class.entry-field--error__input]="errorMessage[prop]"
      [(ngModel)]="shouldObfuscateInput || shouldObfuscate ? obfuscationPattern : val"
      (change)="trigger()"
      (blur)="handleBlur()"
      [maxlength]="maxlength"
      id="{{ componentId }}"
      [disabled]="isState || isDisabled || disableConditionally"
      [readonly]="isReadonly"
      [textMask]="inputMask ? inputMask : defaultMask"
    />
    <label
      *ngIf="!noLabel"
      class="entry-field__label"
      for="{{ componentId }}"
      [class.entry-field--error__label]="errorMessage[prop]"
      [class.entry-field--filled__label]="!errorMessage[prop] && !!val"
    >
      {{ label || placeholder }}
    </label>
  </div>
  <div *ngIf="isServer" class="entry-field__input">{{ val }}</div>
  <p
    class="error-message error-message--entry-field"
    *ngIf="errorMessage[prop] && !isDisabled && !disableConditionally"
  >
    {{ errorMessage[prop] }}
  </p>
</div>
<tooltip *ngIf="isReadonly && !isQuestionLockableNode">
  <icon type="lock" label></icon>
  <div tip>{{ questionItem.readonlyReason }}</div>
</tooltip>
